import React from 'react';
import { Link } from "react-router-dom";
import DateTimeRange from "../../../components/common/DateTimeRange";

const NewSoundSettings = () => {
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <Link to="/vpbx-manager">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to VPBX manager</span>
                </Link>
                <h3>CREATE A SOUND SETTINGS</h3>
                <p>Enter the details for the new sound, including the assigned period and the type to which this sound belongs</p>
              </div>
            </div>
            {/* <div className="uk-width-1-3">
              <div className="dashboardIntro uk-text-right">
                <button>EXPORT DATA</button>
              </div>
            </div> */}
          </div>

          <form>
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">Sound information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Event name</label>
                  <input
                    className="uk-input"
                    type="text"
                    placeholder="Event name"
                    aria-label="Input"
                  />
                </div>
                <div className="uk-width-1-2@m uk-margin">
                  <label>Period</label>
                  <DateTimeRange/>
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Type</label>
                  <select className="uk-select" aria-label="Select">
                    <option value="" selected disabled hidden>
                      Select Menu...
                    </option>
                    <option>Main Menu</option>
                    <option>Option 02</option>
                  </select>
                </div>
                <div className="uk-width-1-2@m uk-margin">
                  <label>Event</label>
                  <select className="uk-select" aria-label="Select">
                    <option value="" selected disabled hidden>
                        Select event
                    </option>
                    <option>Option 01</option>
                    <option>Option 02</option>
                  </select>
                </div>
                
                
                <div className="uk-width-1-1@m uk-margin-top">
                  <label><b>Please select any one flow extensions(file input)</b></label>
                  <span className="fileDisc">Add sound file (only .wav format allowed)</span>
                  <div className="uk-margin-bottom">
                    
                    <div uk-form-custom="target: true">
                      <input type="file" aria-label="Custom controls" accept=".zip" />
                      <input
                        className="uk-input uk-form-width-medium"
                        type="text"
                        placeholder="Choose files"
                        aria-label="Custom controls"
                        disabled
                      />
                    </div>
                    <button className="uk-button fileUploadBtn uk-button-default">Submit</button>
                  </div>
                  <a href="#" className="DownloadFileBtn"> Download sample file</a>
                </div>

                <div className="uk-width-1-1@m uk-float-right">
                    <div className="formActionBtn uk-text-right">
                        <button className="whiteBtn">Cancel</button>
                        <button className="pinkBtn">Save</button>
                    </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default NewSoundSettings